export default __webpack_public_path__ + "static/principles-of-use-dont-dark-255d3f5a836b34758d10df38045a5bd9.png";